import { Button, Input, message } from "antd";
import React, { useEffect, useState } from "react";
import { request } from "../../utils/request";

const WEBHOOK_FIELDS = [
	{
		key: "link_webhook",
		label: "Link Webhook nhắc lịch hẹn — dùng để tự động gửi nhắc lịch hẹn qua Zalo ZNS (trước 24 giờ và trước 2 giờ). Để trống nếu phòng khám này không dùng tính năng này.",
	},
	{
		key: "link_webhook_sinh_nhat_thang",
		label: "Link Webhook sinh nhật theo tháng — gửi ZNS cho khách có sinh nhật trong tháng. Để trống nếu không dùng.",
	},
	{
		key: "link_webhook_sinh_nhat_ngay",
		label: "Link Webhook sinh nhật theo ngày — gửi ZNS đúng ngày sinh nhật của khách. Để trống nếu không dùng.",
	},
	{
		key: "link_webhook_thu_tien",
		label: "Link Webhook thông báo thu tiền — gửi ZNS cho khách ngay khi tạo phiếu thu (pt1). Để trống nếu không dùng.",
	},
];

export default function Settings() {
	const [messageApi, contextHolder] = message.useMessage();
	const [loading, setLoading] = useState(false);
	const [appData, setAppData] = useState(null);
	const [values, setValues] = useState({});

	const handleGetAppData = async () => {
		setLoading(true);
		try {
			const idApp = localStorage.getItem("id_app");
			const res = await request.get("api/app", {
				params: {
					q: JSON.stringify({ _id: idApp }),
					notfields: "__v",
				},
				headers: {
					"X-Access-Token": localStorage.getItem("token"),
					"Content-Type": "application/json",
				},
			});
			const record = res?.data?.[0];
			setAppData(record);
			const next = {};
			WEBHOOK_FIELDS.forEach(({ key }) => {
				next[key] = record?.exfields?.[key] || "";
			});
			setValues(next);
		} catch (error) {
			console.log(error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		handleGetAppData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleSave = async () => {
		setLoading(true);
		try {
			const idApp = localStorage.getItem("id_app");
			await request.put(
				`api/app/${idApp}`,
				{
					...appData,
					exfields: {
						...appData?.exfields,
						...values,
					},
				},
				{
					headers: {
						"X-Access-Token": localStorage.getItem("token"),
						"Content-Type": "application/json",
					},
				},
			);
			messageApi.open({ type: "success", content: "Lưu thành công" });
			handleGetAppData();
		} catch (error) {
			messageApi.open({ type: "error", content: "Lưu thất bại" });
			console.log(error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="p-4 max-w-xl">
			{contextHolder}
			<h2 className="text-lg font-semibold text-[#186b9e] mb-4">
				Cài đặt Webhook ZNS
			</h2>
			<div className="flex flex-col gap-4">
				{WEBHOOK_FIELDS.map(({ key, label }) => (
					<div key={key} className="flex flex-col gap-2">
						<label className="text-sm text-gray-600">{label}</label>
						<Input
							value={values[key]}
							onChange={(e) =>
								setValues({ ...values, [key]: e.target.value })
							}
							placeholder="https://api83.goodapp.vn/webhooks/..."
						/>
					</div>
				))}
				<Button
					type="primary"
					className="btn_primary w-fit"
					loading={loading}
					onClick={handleSave}
				>
					Lưu
				</Button>
			</div>
		</div>
	);
}
